import { gql } from "@apollo/client";

export const RentingsSameUser = gql`
	query RentingsSameUser {
		rentingsSameUser {
			userId
			userInfo {
				_id
				email
				name
				phoneNumber
				addressInfo {
					Address
					postalCode
				}
				localidade
				nif
				avatar
				createdAt
			}
			activeRentings {
				_id
				pricePerDay
				client
				machine
				status
				startedRent
				endedRent
				previsionEndingRent
				hasGT
				hasGD
				gtDocumentNo
				gtDocumentId
				gtPublicLink
				gdPublicLink
				gtShipmentAddressDetail
				gtShipmentPostcode
				gtShipmentCity
				gtShipmentCountry
				machineInfo {
					_id
					name
					ref
					photo
					category
				}
			}
			totalActiveRentings
		}
	}
`; 
